'use client';

import clsx from 'clsx';
import { InputHTMLAttributes, ReactNode, RefCallback, RefObject } from 'react';
import { FieldError } from 'react-hook-form';

interface CheckboxInputProps extends InputHTMLAttributes<HTMLInputElement> {
  ref?: RefObject<HTMLInputElement | null> | RefCallback<HTMLInputElement | null>;
  label?: ReactNode;
  error?: FieldError;
  labelClasses?: string;
  checkboxClass?: string;
  labelTop?: ReactNode;
}

export function CheckboxInput({
  ref,
  className,
  error,
  label,
  labelTop,
  labelClasses,
  checkboxClass,
  ...restProps
}: CheckboxInputProps) {
  const legendClass = clsx('fieldset-legend block', error && 'text-error', labelClasses);
  return (
    <fieldset className={clsx('fieldset w-fit cursor-pointer justify-start gap-3', className)}>
      {labelTop && (
        <legend className={legendClass}>
          {labelTop}
          {restProps.required && '*'}
        </legend>
      )}
      <label className="fieldset-label">
        <input
          ref={ref}
          {...restProps}
          id={restProps.name ? `${restProps.name}-validation` : undefined}
          type="checkbox"
          className={clsx('checkbox checkbox-primary', error && 'checkbox-error', checkboxClass)}
          required={restProps.required}
          checked={restProps.checked}
        />
        {label && (
          <legend className={legendClass}>
            {label}
            {restProps.required && '*'}
          </legend>
        )}
      </label>
    </fieldset>
  );
}
